<template>
    <div class="w-100">
        <div class="filter-header">
            <div class="fs-14 font-weight-bold ml-4">Filters (<span style="color:#ffba00 !important;">{{totalFilters}}</span>)</div>
            <div class="pointer">
                <span>
                    <img class="filter-Images" @click="applyFilter()" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ArrowBgBlue.svg" style="width: 35px;" alt="arrow">
                </span>
                <span >
                    <img class="filter-Images" @click="clearAllSelected()" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ResetBgBlue.svg" alt="reset">
                </span>
                <span @click="closeFilters()">
                    <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                </span>
            </div>
        </div>
        <div class="w-100">
            <div class="row w-100 justify-content-end m-0">
                <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="pt-3">
                    <div class="">
                        <multiselect name="Save_Filter" label="name"
                            class="diginew-multiselect approval-manager filter-multiple mt-1" id="ajax"
                            placeholder="Select previous saved filters"
                            :options="filter_options" v-model="saveFilter"
                            :multiple="false" :searchable="true" :internal-search="false"
                            :clear-on-select="true" :close-on-select="true" :options-limit="40"
                            :max-height="200" :show-no-results="true" :hide-selected="false"
                            :loading="filter_loading" @search-change="getAllFiltersAPI"
                            @open="clearFilterData"
                            openDirection="bottom"
                            @close="updateFilterSelected()"
                        >
                        <template slot="afterList">
                            <div v-observe-visibility="reachedEndOfFilters" />
                        </template>
                        <template slot="noResult">
                            <div v-if="filter_options.length">
                                <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                            <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                        </template>
                        </multiselect>
                        <i class="icon icon-close clear-icon mt-3 pointer" v-if="saveFilter != '' && saveFilter != null" @click="clearApprover()"></i>
                    </div>
                    <span class="text-danger mt-1 fs-12 pointer" v-if="saveFilter != '' && saveFilter != null" @click="removeSavedFilter(saveFilter._id)" style="float:right">Delete Saved Filter</span>
                </div>
                </div>
            </div>
            <div class="">
                <div class="row w-100 m-0">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Ticket ID
                            </span>
                            <multiselect :limit="1" :limit-text="limitTicketId" track-by="ticket_id"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Ticket Number" label="ticket_number"
                                :options="ticket_number_options" v-model="ticket_number"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :loading="ticket_loading" @search-change="getAllTicketAPI"
                                @remove="removeTicket" :blockKeys="['Delete']"
                            >
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.ticket_number }}</span>
                                    <span class="custom__remove pointer" @click="removeTicket(option)">
                                    <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfTickets" />
                            </template>
                            <template slot="noResult">
                                <div v-if="ticket_number_options.length">
                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" company_filter mt-4">
                            <div class="d-flex align-items-center">
                            <span class="fs-13 fw-600 text-filter-label" style="white-space:nowrap">
                                Assigned To
                            </span>
                            </div>
                            <multiselect v-if="assign_to_whom == 'person'" label="name"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2"
                                placeholder="Search & Select Assigned Person" track-by="id"
                                :options="assign_options" v-model="assignedCustomer"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="180" :show-no-results="true" :hide-selected="false"
                                @remove="removeAssignTo" :blockKeys="['Delete']" :loading="assign_loading" @search-change="getAllAssignTo"
                                :limit="1" :limit-text="limitAssignedTo"
                            >
                                <template slot="tag" slot-scope="{ option }">
                                    <span class="custom__tag">
                                    <span class="filterSelectedName">{{ option.name }}</span>
                                        <span class="custom__remove pointer" @click="removeAssignTo(option)">
                                        <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                        </span>
                                    </span>
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfAssigned" />
                                </template>
                                <template slot="noResult">
                                    <div v-if="assign_options.length">
                                        <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Template
                            </span>
                            <multiselect :limit="1" :limit-text="limitTemplate" track-by="id"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Template"
                                :options="template_options" v-model="templates" label="name"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :loading="template_loading" @search-change="getAllTemplates"
                                @remove="removeTemplate" :blockKeys="['Delete']"
                            >
                                <template slot="tag" slot-scope="{ option }">
                                    <span class="custom__tag">
                                    <span class="filterSelectedName">{{ option.name }}</span>
                                        <span class="custom__remove pointer" @click="removeTemplate(option)">
                                        <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                        </span>
                                    </span>
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfTemplateOptions" />
                                </template>
                                <template slot="noResult">
                                    <div v-if="template_options.length">
                                        <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                    </div>
                                    <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Product
                            </span>
                            <multiselect :limit="1" :limit-text="limitProduct" track-by="_id"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Product"
                                :options="allProducts" v-model="product" label="product_name"
                                :multiple="true" :searchable="true" :internal-search="true"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :loading="product_loading" @search-change="getAllProduct"
                                @remove="removeProduct" :blockKeys="['Delete']"
                            >
                                <template slot="tag" slot-scope="{ option }">
                                    <span class="custom__tag">
                                    <span class="filterSelectedName">{{ option.product_name }}</span>
                                        <span class="custom__remove pointer" @click="removeProduct(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                        </span>
                                    </span>
                                </template>
                                <template slot="afterList">
                                    <div v-observe-visibility="reachedEndOfProduct" />
                                </template>
                                <template slot="noResult">
                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                </template>
                            </multiselect>
                        </div>
                    </div> -->
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Status
                            </span>
                            <multiselect
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Status" :limit="1" :limit-text="limitStatus"
                                :options="pending_options" v-model="pending"
                                :multiple="true" :searchable="true" :internal-search="true"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false" :blockKeys="['Delete']"
                            >
                            <template slot="tag" slot-scope="{ option }">
                                <span v-if="option.ticket_status" class="custom__tag">
                                    <span class="filterSelectedName">{{ option.ticket_status }}</span>
                                    <span class="custom__remove pointer" @click="removeStatus(option)">
                                    <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                                <span v-else class="custom__tag">
                                    <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer" @click="removeStatus(option)">
                                    <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                    </span>
                                </span>

                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mt-4">
                        <span class="text-filter-label fw-600 filteLabel">Creation Date</span>
                        <div class="mt-2 d-flex align-items-center">
                            <date-picker
                                ref="picker"
                                v-model="temp_created_date"
                                name="actiondate"
                                class="filterdate filter-disable filter-date-underline policy-date-popup mr-1 w-100"
                                format="MM/DD/YYYY"
                                type="date"
                                :editable="true"
                                lang="en"
                                :clearable="false"
                                confirm
                                range
                                separator= ' - '
                                confirm-text="APPLY"
                                @change="updatecreationDate()"
                            >
                            <!-- <template slot="input" slot-scope="picker">{{ temp_created_date[0] | date }} - {{ temp_created_date[1] | date }}
                            </template> -->
                            </date-picker>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Tag
                            </span>
                            <multiselect :limit="1" :limit-text="limitTagId" track-by="tags"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Tags" label="tags"
                                :options="tag_options" v-model="entered_tag"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :loading="tag_loading" @search-change="getAllTagsAPI"
                                @remove="removeTags" :blockKeys="['Delete']"
                            >
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.tags }}</span>
                                    <span class="custom__remove pointer" @click="removeTags(option)">
                                    <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfTagOptions" />
                            </template>
                            <template slot="noResult">
                                <div v-if="tag_options.length">
                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class=" mt-4">
                            <span class="fs-13 fw-600 text-filter-label">
                                Approvers
                            </span>
                            <multiselect :limit="1" :limit-text="limitApproversId"
                                class="diginew-multiselect diginew-multiselect-underline  filter-multiple mt-2" id="ajax"
                                placeholder="Select Approvers" label="name" track-by="id"
                                :options="approvers_options" v-model="approvers"
                                :multiple="true" :searchable="true" :internal-search="false"
                                :clear-on-select="true" :close-on-select="false" :options-limit="40"
                                :max-height="200" :show-no-results="true" :hide-selected="false"
                                :loading="approvers_loading" @search-change="getAllApproversAPI"
                                :blockKeys="['Delete']"
                            >
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option.name }}</span>
                                    <span class="custom__remove pointer" @click="removeApprovers(option)">
                                    <i class="icon icon-close fs-16 text-brownish-grey"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="afterList">
                                <div v-observe-visibility="reachedEndOfApproversOptions" />
                            </template>
                            <template slot="noResult">
                                <div v-if="approvers_options.length">
                                    <div class="digi-table-loader d-flex justify-content-center" id="spinner" style="margin: 0 auto">
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                        <div></div>
                                    </div>
                                </div>
                                <div v-else class="text-secondary text-center fw-600">No Results Found</div>
                            </template>
                            </multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row w-100 mt-4">
                <div class="col-lg-4 col-md-4 col-sm-4"></div>
                <div class="col-lg-4 col-md-4 col-sm-4"></div>
                <div class="col-lg-4 col-md-4 col-sm-4 d-flex mt-2">
                    <div class="w-100 d-flex align-items-end justify-content-end mb-2">
                        <div class="ml-2">
                            <button :disabled="disable_apply" class="btn btn-new-primary btn-smm ml-2 text-white" @click="applyFilter()">
                                Apply
                            </button>
                        </div>
                        <div class="ml-2">
                            <button class="btn btn-success btn-smm ml-2 d-flex align-items-center" :disabled="totalFilters == 0" style="color:#fff !important;" @click="saveFilterAPI()">
                                Save the search
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <filter-save-modal modal_name="save-filter" @filterSaved="filterSaved"></filter-save-modal> -->
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import VueTagsInput from "@johmun/vue-tags-input";
import ticket from '../mixins/ticket.js';
import crm from '../mixins/crm.js';
import scm from '../mixins/scm.js';
import { EventBus } from '../eventBus/nav-bar-event.js';
// import FilterSaveModal from "../ArchieveTickets/FilterSaveModal";
import { SweetModal } from 'sweet-modal-vue'
// import { debounce } from 'lodash';
import debounce from 'lodash/debounce';
export default {
    props:['showfilterData'],
    mixins:[ticket,crm,scm],
    components:{
        // FilterSaveModal,
        SweetModal,
        VueTagsInput
    },
    data(){
        return{
            entered_tag: [],
            success_msg:'',
            warning_msg:'',
            save_filter:["Design, Devlopment","Low and High","Phone, Mail"],
            saveFilter:'',
            ticket_number:[],
            ticket_number_options:[],
            template_options: [],
            templates: [],
            disable_apply: false,
            template_loading: false,
            template_scrollable: false,
            template_count: 0,
            template_visible: false,
            temp_allTemplates: false,
            ticket_loading:false,
            temp_ticket_number_options:[],
            customer_name:[],
            company_name:[],
            vendor_name:[],
            modified_date_to:'',
            branch_option:[],
            branch:[],
            department_options:[],
            department:[],
            product:[],
            priority_options:['Low','Medium','High'],
            priority:[],
            pending:[],
            pending_options:['Open','Inprogress','Fixed','Closed','Reopen'],
            ticket_options:['Base','Service'],
            ticket_type:'',
            creation_options:[],
            creation_type:'',
            assigned_to_options:[],
            assigned_to:'',
            assign_to_whom:'person',
            template_options:[],
            template_type:[],
            tickets_visible:false,
            ticket_scrollable:false,
            ticket_count:0,
            search_key:'',
            customer_loading:false,
            customer_options:[],
            temp_customer_options:[],
            customer_count:0,
            customer_scrollable:false,
            cutomer_visible:false,
            vendor_options:[],
            temp_vendor_options:[],
            vendor_loading:false,
            vendor_visible:false,
            vendor_scrollable:false,
            vendor_count:0,
            product_loading:false,
            product_scrollable:false,
            product_count:0,
            allProducts:[],
            temp_allProducts:[],
            product_visible:false,
            showSaveAs:true,
            company_options:[],
            company_loading:false,
            company_scrollable:false,
            temp_company_options:false,
            company_count:0,
            company_visible:false,
            created_date:[],
            temp_created_date:[],
            last_modified_date:[],
            temp_last_modified_date:[],
            assignedCustomer:[],
            assign_loading:false,
            temp_assign_options:[],
            assign_scrollable:false,
            assign_count:0,
            assign_options:[],
            assign_visible:false,
            behalf_of_whom:'customer',
            behalf_options:[],
            behalf_selected:[],
            user_options:[],
            user_count:0,
            temp_user_options:[],
            user_loading:false,
            user_scrollable:false,
            user_visible:false,
            filter_visible:false,
            filter_scrollable:false,
            filter_loading:false,
            filter_count:0,
            temp_filter_options:[],
            filter_options:[],
            jobType:'',
            tag_options: [],
            tag_loading: false,
            tags_visible: false,
            tags_scrollable:false,
            tag_count:0,
            temp_tag_options:[],
            // filterName:''
            approvers: [],
            approvers_visible: false,
            approvers_options: [],
            approvers_loading: false,
            approvers_scrollable: false,
            temp_approvers_options: [],
            approvers_count: 0,
        }
    },
    methods:{
        clearApprover(){
            this.saveFilter = ''
            this.clearAllSelected()
        },
        tagsChangeData(update_tag, index){
            this.tag_array[index]=update_tag
            this.$forceUpdate()
        },
        removeBehalfOf(option){
            this.behalf_selected.forEach((el,index)=>{
                if(el.id == option.id){
                    this.behalf_selected.splice(index,1)
                }
            })
        },
        updateOnBehalf(){
            this.behalf_selected = []
        },
        updateAssignTo(){
           this.assignedCustomer = []
        },
        convertFilter(str) {
            var date = new Date(str),
                mnth = ("0" + (date.getMonth() + 1)).slice(-2),
                day = ("0" + date.getDate()).slice(-2);
            return [day, mnth, date.getFullYear()].join("-");
        },
        updatecreationDate(){
            if(this.temp_created_date){
                let value = this.convertFilter(this.temp_created_date[0])
                let value1 = this.convertFilter(this.temp_created_date[1])
                let newValue = [value,value1]
                this.created_date = newValue
            }else{
                this.created_date = []
                this.temp_created_date = []
            }
        },
        updatelastDate(){
            if(this.temp_last_modified_date){
                let value = this.convertFilter(this.temp_last_modified_date[0])
                let value1 = this.convertFilter(this.temp_last_modified_date[1])
                let newValue = [value,value1]
                this.last_modified_date = newValue
            }else{
                this.last_modified_date = []
                this.temp_last_modified_date = []
            }
        },
        showSave(){
            if (!this.showSaveAs) {
                this.showSaveAs = true;
            } else {
                this.showSaveAs = false;
            }
        },
        closeFilters(){
            this.$emit('hideFilters')
        },
        limitTicketId(count){
            return `+ ${count} more`
        },
        limitTagId(count){
            return `+ ${count} more`
        },
        limitApproversId(count){
            return `+ ${count} more`
        },
        limitTemplate(count){
            return `+ ${count} more`
        },
        limitAssignedTo(count){
            return `+ ${count} more`
        },
        limitProduct(count){
            return `+ ${count} more`
        },
        limitStatus(count){
            return `+ ${count} more`
        },
        removeAssignTo(option){
            this.assignedCustomer.forEach((el,index)=>{
                if(el.id == option.id){
                    this.assignedCustomer.splice(index,1)
                }
            })
        },
        removePriority(option){
            this.priority.forEach((el,index)=>{
                if(el == option){
                    this.priority.splice(index,1)
                }
            })
        },
        removeJobType(option){
            this.jobType.forEach((el,index)=>{
                if(el == option){
                    this.jobType.splice(index,1)
                }
            })
        },
        removeStatus(option){
            this.pending.forEach((el,index)=>{
                if(el == option){
                    this.pending.splice(index,1)
                }
            })
        },
        removeTags(option){
            this.entered_tag.forEach((el,index)=>{
                if(el.tags == option.tags){
                    this.entered_tag.splice(index,1)
                }
            })
        },
        removeTicket(option){
            this.ticket_number.forEach((el,index)=>{
                if(el.ticket_number == option.ticket_number){
                    this.ticket_number.splice(index,1)
                }
            })
        },
        removeCustomer(option){
            this.customer_name.forEach((el,index)=>{
                if(el.email == option.email){
                    this.customer_name.splice(index,1)
                }
            })
        },
        removeCompany(option){
            this.company_name.forEach((el,index)=>{
                if(el.company_id == option.company_id){
                    this.company_name.splice(index,1)
                }
            })
        },
        removeVendor(option){
            this.vendor_name.forEach((el,index)=>{
                if(el.name.id == option.name.id){
                    this.vendor_name.splice(index,1)
                }
            })
        },
        removeBranch(option){
            this.branch.forEach((el,index)=>{
                if(el._id == option._id){
                    this.branch.splice(index,1)
                }
            })
        },
        removeDept(option){
            this.department.forEach((el,index)=>{
                if(el.department == option.department){
                    this.department.splice(index,1)
                }
            })
        },
        removeTemplate(option){
            this.templates.forEach((el,index)=>{
                if(el.id == option.id){
                    this.templates.splice(index,1)
                }
            })
        },
        removeProduct(option){
            this.product.forEach((el,index)=>{
                if(el._id == option._id){
                    this.product.splice(index,1)
                }
            })
        },
        removeTicketType(option){
            this.ticket_type.forEach((el,index)=>{
                if(el._id == option._id){
                    this.ticket_type.splice(index,1)
                }
            })
        },
        removeApprovers(option){
            this.approvers.forEach((el, index) => {
                if(el.id == option.id){
                    this.approvers.splice(index, 1)
                }
            })
        },
        async clearFilterData(){
            this.filter_options = []
            this.filter_count = 0
            try {
                this.filter_loading = true
                let params ={
                    skip:this.filter_count,
                    limit:10,
                    search_key:search_key,
                    is_mobile:false
                }
                let res = await this.getAllFilters(params)
                this.filter_options = res.response.filter_names
                this.filter_count = this.temp_filter_options.length
                this.filter_loading = false
                this.filter_scrollable = false
            } catch (reason) {

            }
        },
        async getAllFiltersAPIDebouncer(search_key){
            try {
                this.filter_count = 0
                this.filter_loading = true
                let params ={
                    skip:this.filter_count,
                    limit:10,
                    search_key:search_key,
                    is_mobile:false
                }
                let res = await this.getAllFilters(params)
                this.filter_options = res.response.filter_names
                this.filter_count = this.temp_filter_options.length
                this.filter_loading = false
                this.filter_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfFilters(reached){
            this.filter_visible = reached
            if (reached) {
                if (this.filter_scrollable == false) {
                    this.filter_loading = true
                    let params ={
                        skip:this.filter_count,
                        limit:10,
                        search_key:this.search_key,
                        is_mobile:false
                    }
                    let response = await this.getAllFilters(params)
                    this.temp_filter_options = response.response.filter_names.length;
                    if (response.response.skip == this.filter_count) {
                        if (this.temp_filter_options > 0) {
                            let tempFiles = response.response.filter_names;
                            tempFiles.forEach(el => {
                                this.filter_options.push(el);
                            });
                            this.filter_count += response.response.filter_names.length;
                            this.filter_loading = false
                        } else {
                            this.filter_scrollable = true
                            this.filter_loading = false
                        }
                    }
                    this.filter_loading = false
                }
            }
        },
        async getAllTagsAPIDebouncer(search_key){
            this.tag_options = []
            this.tag_count = 0
            this.tag_loading = true
            try {
                let params ={
                    "skip": this.tag_count,
                    "limit": 10,
                    "search_key": search_key
                }
                let res = await this.getAllTags(params)
                this.tag_options = res.response.tags
                // let uniqueArray = res.response.tags.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.tags.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.tag_options = uniqueArray
                this.tag_count = this.temp_tag_options
                this.tag_loading = false
                this.tags_scrollable = false
            } catch (reason) {

            }
        },
        async getAllApproversAPIDebouncer(search_key){
            this.approvers_options = []
            this.approvers_count = 0
            this.approvers_loading = true
            this.search_key = search_key
            try {
                let params ={
                    "search_key": this.search_key,
                    "limit": 10, 
                    "skip": 0, 
                    // "filter_id": ""
                }
                let res = await this.getApproversList(params)

                let uniqueArray = res.response.users.filter((value, index_dd) => {
                    const _value = JSON.stringify(value);
                    return index_dd === res.response.users.findIndex(obj => {
                        return JSON.stringify(obj) === _value;
                    });
                });
                this.approvers_options = uniqueArray

                this.approvers_count = this.temp_approvers_options
                this.approvers_loading = false
                this.approvers_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfApproversOptions(reached){
            this.approvers_visible = reached
            if (reached) {
                if (this.approvers_scrollable == false) {
                    this.approvers_loading = true
                    let params ={
                        skip:this.approvers_count,
                        limit:10,
                        search_key:this.search_key,
                    }
                    let response = await this.getApproversList(params)
                    this.temp_approvers_options = response.response.users.length;
                    if (response.response.skip == this.approvers_count) {
                        if (this.temp_approvers_options > 0) {
                            let tempFiles = response.response.users;
                            tempFiles.forEach(el => {
                                if(el.tags !== ''){
                                    this.approvers_options.push(el);
                                }
                            });
                            this.approvers_count += response.response.users.length;
                            this.approvers_loading = false
                        } else {
                            this.approvers_scrollable = true
                            this.approvers_loading = false
                        }
                    }
                    this.approvers_loading = false
                }
            }
        },
        async reachedEndOfTagOptions(reached){
            this.tags_visible = reached
            if (reached) {
                if (this.tags_scrollable == false) {
                    this.tag_loading = true
                    let params ={
                        skip:this.tag_count,
                        limit:10,
                        search_key:this.search_key,
                    }
                    let response = await this.getAllTags(params)
                    this.temp_tag_options = response.response.tags.length;
                    if (response.response.skip == this.tag_count) {
                        if (this.temp_tag_options > 0) {
                            let tempFiles = response.response.tags;
                            tempFiles.forEach(el => {
                                if(el.tags !== ''){
                                    this.tag_options.push(el);
                                }
                            });
                            this.tag_count += response.response.tags.length;
                            this.tag_loading = false
                        } else {
                            this.tags_scrollable = true
                            this.tag_loading = false
                        }
                    }
                    this.tag_loading = false
                }
            }
        },
        async getAllTicketAPIDebouncer(search_key){
            this.ticket_number_options = []
            this.ticket_count = 0
            this.ticket_loading = true
            this.search_key = search_key
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key,
                }
                let res = await this.getAllTickets(params)
                // let uniqueArray = res.response.all_tickets.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.all_tickets.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.ticket_number_options = uniqueArray
                this.ticket_number_options = res.response.all_tickets
                this.ticket_count = this.temp_products.length
                this.ticket_loading = false
                this.ticket_scrollable = false
            } catch (reason) {
                console.log(reason)
                this.ticket_loading = false
            }
        },
        async reachedEndOfTickets(reached){
            this.tickets_visible = reached
            if (reached) {
                if (this.ticket_scrollable == false) {
                    this.ticket_loading = true
                    let params ={
                        skip:this.ticket_count,
                        limit:10,
                        search_key:this.search_key,
                        is_mobile:false,
                        is_service_ticket:false,
                        sort_key: "ticket_number",
                    }
                    let response = await this.getAllTickets(params)
                    this.temp_ticket_number_options = response.response.all_tickets.length;
                    if (response.response.skip == this.ticket_count) {
                        if (this.temp_ticket_number_options > 0) {
                            let tempFiles = response.response.all_tickets;
                            tempFiles.forEach(el => {
                                this.ticket_number_options.push(el);
                            });
                            let uniqueArray = this.ticket_number_options.filter((value, index_dd) => {
                                const _value = JSON.stringify(value);
                                return index_dd === this.ticket_number_options.findIndex(obj => {
                                    return JSON.stringify(obj) === _value;
                                });
                            });
                            this.ticket_number_options = uniqueArray
                            this.ticket_count += response.response.all_tickets.length;
                            this.ticket_loading = false
                        } else {
                            this.ticket_scrollable = true
                            this.ticket_loading = false
                        }
                    }
                    this.ticket_loading = false
                }
            }
        },
        async getAllCompany(search_key){
            try {
                this.company_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForCompanyFilter(params)
                this.company_options = res.response.company_names
                this.company_count = this.temp_company_options.length
                this.company_loading = false
                this.company_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfCompany(reached){
            this.company_visible = reached
            if (reached) {
                if (this.company_scrollable == false) {
                    this.company_loading = true
                    let params ={
                        skip:this.company_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForCompanyFilter(params)
                    this.temp_company_options = response.response.company_names.length;
                    if (response.response.skip == this.company_count) {
                        if (this.temp_company_options > 0) {
                            let tempFiles = response.response.company_names;
                            tempFiles.forEach(el => {
                                this.company_options.push(el);
                            });
                            this.company_count += response.response.company_names.length;
                            this.company_loading = false
                        } else {
                            this.company_scrollable = true
                            this.company_loading = false
                        }
                    }
                    this.company_loading = false
                }
            }
        },
        async getAllUsers(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserListFilter(params)
                this.user_options = res.response.users
                this.user_count = this.temp_user_options.length
                this.user_loading = false
                this.user_scrollable = false
                this.user_options.forEach((el,index)=>{
                    el['label'] = el.name
                    el['id'] = el.id
                })
            } catch (reason) {

            }
        },
        async reachedEndOfUsers(reached){
            this.user_visible = reached
            if (reached) {
                if (this.user_scrollable == false) {
                    this.user_loading = true
                    let params ={
                        skip:this.user_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserListFilter(params)
                    this.temp_user_options = response.response.users.length;
                    if (response.response.skip == this.user_count) {
                        if (this.temp_user_options > 0) {
                            let tempFiles = response.response.users;
                            tempFiles.forEach(el => {
                                this.user_options.push(el);
                            });
                            this.user_count += response.response.users.length;
                            this.user_loading = false
                        } else {
                            this.user_scrollable = true
                            this.user_loading = false
                        }
                        this.user_options.forEach((el,index)=>{
                            el['label'] = el.name
                            el['id'] = el.id
                        })
                    }
                    this.user_loading = false
                }
            }
        },
        async getAllCustomers(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getCustomerForTicketsFilter(params)
                this.customer_options = res.response.customer_names
                this.customer_count = this.temp_customer_options.length
                this.customer_loading = false
                this.customer_scrollable = false
                this.customer_options.forEach((el,index)=>{
                    el['label'] = el.customer_name
                    el['id'] = el._id
                })
            } catch (reason) {

            }
        },
        async reachedEndOfCustomer(reached){
            this.cutomer_visible = reached
            if (reached) {
                if (this.customer_scrollable == false) {
                    this.customer_loading = true
                    let params ={
                        skip:this.customer_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getCustomerForTicketsFilter(params)
                    this.temp_customer_options = response.response.customer_names.length;
                    if (response.response.skip == this.customer_count) {
                        if (this.temp_customer_options > 0) {
                            let tempFiles = response.response.customer_names;
                            tempFiles.forEach(el => {
                                this.customer_options.push(el);
                            });
                            this.customer_count += response.response.customer_names.length;
                            this.customer_loading = false
                        } else {
                            this.customer_scrollable = true
                            this.customer_loading = false
                        }
                        this.customer_options.forEach((el,index)=>{
                            el['label'] = el.customer_name
                            el['id'] = el._id
                        })
                    }
                    this.customer_loading = false
                }
            }
        },
        async getAllVendors(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getSCMVendorsFilter(params)
                this.vendor_options = res.response.vendor_names
                this.vendor_count = this.temp_vendor_options.length
                this.vendor_loading = false
                this.vendor_scrollable = false
                this.vendor_options.forEach((el,index)=>{
                    el['label'] = el.vendor_name
                    el['id'] = el._id
                })
            } catch (reason) {

            }
        },
        async reachedEndOfVendors(reached){
            this.vendor_visible = reached
            if (reached) {
                if (this.vendor_scrollable == false) {
                    this.vendor_loading = true
                    let params ={
                        skip:this.vendor_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getSCMVendorsFilter(params)
                    this.temp_vendor_options = response.response.vendor_names.length;
                    if (response.response.skip == this.vendor_count) {
                        if (this.temp_vendor_options > 0) {
                            let tempFiles = response.response.vendor_names;
                            tempFiles.forEach(el => {
                                this.vendor_options.push(el);
                            });
                            this.vendor_count += response.response.vendor_names.length;
                            this.vendor_loading = false
                        } else {
                            this.vendor_scrollable = true
                            this.vendor_loading = false
                        }
                        this.vendor_options.forEach((el,index)=>{
                            el['label'] = el.vendor_name
                            el['id'] = el._id
                        })
                    }
                    this.vendor_loading = false
                }
            }
        },
        async loadBranchs(){
            try {
                let params = {
                    skip:0,
                    limit:20,
                    company_id:this.loggedInUser.company_id
                }
                let res = await this.getBranchsForTicketsFilter(params)
                if(res.status_id == 1){
                    this.branch_option = res.response.branch_names
                }
            } catch (reason) {

            }
        },
        async loadDept(){
            try {
                let params = {
                    skip:0,
                    limit:20,
                    search_key:''
                }
                let res = await this.getDepartmentsFilter(params)
                if(res.status_id == 1){
                    this.department_options = res.response.department_names
                }
            } catch (reason) {

            }
        },
        async getAllProduct(search_key){
            try {
                this.product_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getTicketProducts(params)
                this.allProducts = res.response.product_names
                this.product_count = this.temp_allProducts.length
                this.product_loading = false
                this.product_scrollable = false
            } catch (reason) {

            }
        },
        async getAllTemplatesDebouncer(search_key){
            this.template_options = []
            try {
                this.template_loading = true
                let params ={
                    "skip": 0,
                    "limit": 10,
                    "search_key": search_key
                }
                let res = await this.getTicketTemplates(params)
                this.template_options = res.response.templates
                // let uniqueArray = res.response.templates.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.templates.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.template_options = uniqueArray
                this.template_count = this.temp_allProducts.length
                this.template_loading = false
                this.template_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfTemplateOptions(reached){
            this.template_visible = reached
            if (reached) {
                if (this.template_scrollable == false) {
                    this.template_loading = true
                    let params = {
                        skip:this.template_count,
                        limit:10,
                        search_key:this.search_key,
                    }
                    let response = await this.getTicketTemplates(params)
                    this.temp_allTemplates = response.response.templates.length;
                    if (response.response.skip == this.template_count) {
                        if (this.temp_allTemplates > 0) {
                            let tempFiles = response.response.templates;
                            tempFiles.forEach(el => {
                                if(el.name !== ''){
                                    this.template_options.push(el);
                                }
                            });
                            this.template_count += response.response.templates.length;
                            this.template_loading = false
                        } else {
                            this.template_scrollable = true
                            this.template_loading = false
                        }
                    }
                    this.template_loading = false
                }
            }
        },
        async reachedEndOfProduct(reached){
            this.product_visible = reached
            if (reached) {
                if (this.product_scrollable == false) {
                    this.product_loading = true
                    let params ={
                        skip:this.product_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getTicketProducts(params)
                    this.temp_allProducts = response.response.product_names.length;
                    if (response.response.skip == this.product_count) {
                        if (this.temp_allProducts > 0) {
                            let tempFiles = response.response.product_names;
                            tempFiles.forEach(el => {
                                this.allProducts.push(el);
                            });
                            this.product_count += response.response.product_names.length;
                            this.product_loading = false
                        } else {
                            this.product_scrollable = true
                            this.product_loading = false
                        }
                    }
                    this.product_loading = false
                }
            }
        },
        async getAllAssignToDebouncer(search_key){
            try {
                this.assign_loading = true;
                this.assign_options = []
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTicketsFilter(params)
                // let uniqueArray = res.response.users.filter((value, index_dd) => {
                //     const _value = JSON.stringify(value);
                //     return index_dd === res.response.users.findIndex(obj => {
                //         return JSON.stringify(obj) === _value;
                //     });
                // });
                // this.assign_options = uniqueArray
                this.assign_options = res.response.users
                this.assign_count = this.temp_assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {

            }
        },
        async reachedEndOfAssigned(reached){
            this.assign_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForTicketsFilter(params)
                    this.temp_assign_options = response.response.users.length;
                    if (response.response.skip == this.assign_count) {
                        if (this.temp_assign_options > 0) {
                            let tempFiles = response.response.users;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.users.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
        async loadTemplates(){
            try {
                let params = {
                    skip:0,
                    limit:10,
                    search_key:''
                }
                let res = await this.templatedForDropdown(params)
                if(res.status_id == 1){
                    this.template_options = res.response.all_templates
                }
            } catch (reason) {

            }
        },
        clearAllSelected(){
            let newData = {
                filterData:{
                    created_templates: [],
                    approvers: [],
                    assigned_to:[],
                    branch:[],
                    company_name:[],
                    created_date:[],
                    department:[],
                    last_modified_date:[],
                    priority:[],
                    product:[],
                    status:[],
                    ticket_number:[],
                    template:[],
                    behalf_selected:[],
                    behalf_of_whom:'customer',
                    assign_to_whom:'person',
                    ticket_type:'',
                    created_tags: [],
                },
                showfilterData:{
                    created_templates: [],
                    approvers: [],
                    assigned_to:[],
                    branch:[],
                    company_name:[],
                    created_date:[],
                    department:[],
                    last_modified_date:[],
                    priority:[],
                    product:[],
                    status:[],
                    ticket_number:[],
                    template:[],
                    behalf_selected:[],
                    behalf_of_whom:'customer',
                    assign_to_whom:'person',
                    ticket_type:'',
                    created_tags: []
                }
            }
            localStorage.setItem("StoreFilterData", JSON.stringify(newData))
            this.templates = []
            this.entered_tag = []
            this.approvers = []
            this.temp_created_date = []
            this.created_date = []
            this.last_modified_date = []
            this.branch = []
            this.ticket_number = []
            this.priority = []
            this.company_name = []
            this.department = []
            this.pending = []
            this.product = []
            this.assignedCustomer = []
            this.template_type = []
            this.behalf_selected=[]
            this.ticket_type = '',
            this.jobType = ''
            this.saveFilter= ''
        },
        applyFilter(){
            let params = {
                created_templates :[...new Set(this.templates.map(x =>x.id))],
                created_tags:[...new Set(this.entered_tag.map(x =>x.tags))],
                approvers: [...new Set(this.approvers.map(x => x.id))],
                created_date:this.created_date,
                last_modified_date:this.last_modified_date,
                branch:[...new Set(this.branch.map(x =>x._id))],
                ticket_number:[...new Set(this.ticket_number.map(x =>x.ticket_number))],
                priority:this.priority,
                company_name:[...new Set(this.company_name.map(x =>x.company_id))],
                department:[...new Set(this.department.map(x =>x.department))],
                status:[...new Set(this.pending.map(x =>x.ticket_status ? x.ticket_status.replace(/[^\w\s]/gi, '') : x.replace(/[^\w\s]/gi, '')))],
                product:[...new Set(this.product.map(x =>x._id))],
                assigned_to:[...new Set(this.assignedCustomer.map(x =>x.id))],
                template:[...new Set(this.template_type.map(x =>x.id))],
                ticket_type:this.ticket_type,
                assign_to_whom:this.assign_to_whom,
                behalf_of_whom:this.behalf_of_whom,
                behalf_selected:[...new Set(this.behalf_selected.map(x => x.id))],
                jobType:this.jobType,
            };
            for(let i=0; i<params.status.length;i++){
                params.status[i] = params.status[i].toLowerCase()
            }
            let params1 = {
                saveFilter: this.saveFilter,
                created_templates: this.templates,
                created_tags: this.entered_tag,
                approvers: this.approvers,
                created_date:this.created_date,
                last_modified_date:this.last_modified_date,
                branch:this.branch,
                ticket_number:this.ticket_number,
                priority:this.priority,
                company_name:this.company_name,
                department:this.department,
                status:this.pending,
                product:this.product,
                assigned_to:this.assignedCustomer,
                template:this.template_type,
                ticket_type:this.ticket_type,
                assign_to_whom:this.assign_to_whom,
                behalf_of_whom:this.behalf_of_whom,
                behalf_selected:this.behalf_selected,
                jobType:this.job_type
            }
            let newData = {
                value:params,
                value1:params1
            }
            this.$emit('appliedFilter',newData)
            this.clearAllSelected()
            this.closeFilters()
            EventBus.$emit('UpdateTab')
        },
        // cancelFilterName(){
        //     this.filterName = ''
        // },
        async filterSaved(value){
            try {
                let params = {
                    name:value,
                    filters:{
                        assigned_to:{
                            select_all:false,
                            to:this.assign_to_whom,
                            value:[...new Set(this.assignedCustomer.map(x =>x.id))],
                        },
                        date_range:{
                            created_date:this.created_date,
                            modification_date:this.last_modified_date,
                        },
                        status:{
                            value:[...new Set(this.pending.map(x =>(x.ticket_status ? x.ticket_status.replace(/[^\w\s]/gi, '') : x.replace(/[^\w\s]/gi, ''))))]
                        },
                        ticket_number:{
                            select_all:false,
                            value:[...new Set(this.ticket_number.map(x =>x.ticket_number))]
                        },
                        tag :{
                            select_all: false,
                            value: [...new Set(this.entered_tag.map(x =>x.tags))]
                        },
                        template: {
                            select_all: false,
                            value: [...new Set(this.templates.map(x =>x.id))]
                        },
                        approvers: {
                            select_all: false,
                            value: [...new Set(this.approvers.map(x => x.id))]
                        }
                    }
                }
                let res = await this.filterSave(params)
                this.$emit('showSuccessPopup', res.response.success_message)
                setTimeout(() => {
                    this.clearAllSelected()
                }, 3000);
            } catch (reason) {
                console.log(reason)
                this.$emit('showWarningPopup', reason)
            }
        },
        async saveFilterAPI(){
            let temp_filter_data = {
                assigned_to:{
                    select_all:false,
                    to:this.assign_to_whom,
                    value:[...new Set(this.assignedCustomer.map(x =>x.id))],
                },
                date_range:{
                    created_date:this.created_date,
                    modification_date:this.last_modified_date,
                },
                status:{
                    value:[...new Set(this.pending.map(x =>(x.ticket_status ? x.ticket_status.replace(/[^\w\s]/gi, '') : x.replace(/[^\w\s]/gi, ''))))]
                },
                ticket_number:{
                    select_all:false,
                    value:[...new Set(this.ticket_number.map(x =>x.ticket_number))]
                },
                tag :{
                    select_all: false,
                    value: [...new Set(this.entered_tag.map(x =>x.tags))]
                },
                template: {
                    select_all: false,
                    value: [...new Set(this.templates.map(x =>x.id))]
                },
                approvers: {
                    select_all: false,
                    value: [...new Set(this.approvers.map(x => x.id))]
                }
            }
            this.$emit('openSaveFilter', temp_filter_data)
        },
        async updateFilterSelected(){
            this.disable_apply = true
            try {
                if(this.saveFilter){
                    let params = {
                        filter_id:this.saveFilter._id
                    }
                    let res = await this.getFilterById(params)
                    this.updateView(res.response)
                    this.disable_apply = false
                }
            } catch (reason) {
                this.disable_apply = false
            }
        },
        async removeSavedFilter(id){
            try{
                let params = {
                    filter_id: id
                }
                let response = await this.deleteSavedFilterById(params)
                if (response.status_id == 1){
                    this.$emit('showSuccessPopup', response.response)
                    // this.success_msg = response.response
                    // this.$refs.success_modal.open();
                    setTimeout(() => {
                        // this.$refs.success_modal.close();
                        this.saveFilter = ''
                        this.clearAllSelected()
                    }, 3000);
                } else if(response.status_id == 0){
                    this.$emit('showWarningPopup', response.reason)
                    // this.warning_msg = response.reason
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    // }, 3000);
                }
            } catch(err) {
                this.$emit('showWarningPopup', err)
                // this.warning_msg =err
                // this.$refs.warning_modal.open();
                // setTimeout(() => {
                //     this.$refs.warning_modal.close();
                // }, 3000);
            }
        },
        updateView(params){
            this.templates = params.template.value
            this.approvers = params.approvers.value
            this.entered_tag = params.tag.value
            this.ticket_number = [...params.ticket_number.value]
            let temp_ticket_number =[]
            for(let i=0; i<this.ticket_number.length; i++)
                {
                    temp_ticket_number.push({ticket_number: this.ticket_number[i]})
                }
            this.ticket_number = temp_ticket_number
            this.pending = params.status.value
            this.assign_to_whom = params.assigned_to.to
            this.assignedCustomer = params.assigned_to.value
            this.created_date = params.date_range.created_date
            if(this.created_date.length){
                this.temp_created_date = [];
                this.temp_created_date[0] = this.dateFormat(this.created_date[0],'yyyy-MM-dd')
                this.temp_created_date[1] = this.dateFormat(this.created_date[1],'yyyy-MM-dd')
            } else{
                this.temp_created_date = []
                // this.temp_created_date.splice(0,this.temp_created_date.length)
            }
            this.last_modified_date = params.date_range.last_modified_date
            this.branch = params.branch.value
            this.priority = params.priority.value
            this.company_name = params.company_name.value
            this.department = params.department.value
            this.product = [...params.product.value]
            this.product.forEach((x, index) => {
                this.product[index] = {
                    product_name: x.name,
                    _id: x.id
                }
            })
            this.template = params.template.value
            this.ticket_type = params.ticket_type
            this.behalf_of_whom = params.on_behalf_of.for
            this.behalf_selected= params.on_behalf_of.value
            this.jobType = params.jobType.value
        },
        dateFormat(inputDate, format) {
            let temp_date = inputDate.slice(0,2)
            let temp_month = inputDate.slice(3,5) - 1
            let temp_year = inputDate.slice(6,)
            //parse the input date
            const date = new Date(temp_year, temp_month, temp_date);
            //extract the parts of the date
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            //replace the month
            format = format.replace("MM", month.toString().padStart(2,"0"));

            //replace the year
            if (format.indexOf("yyyy") > -1) {
                format = format.replace("yyyy", year.toString());
            } else if (format.indexOf("yy") > -1) {
                format = format.replace("yy", year.toString().substr(2,2));
            }

            //replace the day
            format = format.replace("dd", day.toString().padStart(2,"0"));

            return format;
        }
    },
    computed:{
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        job_type_options(){
            if(this.getGeneralSettings && this.getGeneralSettings.job_type){
                return this.getGeneralSettings.job_type
            }
        },
        // pending_options(){
        //     if(this.getGeneralSettings && this.getGeneralSettings.ticket_status){
        //         return this.getGeneralSettings.ticket_status
        //     }
        // },
        showPriority(){
            if(this.getGeneralSettings && this.getGeneralSettings.display_ticket_priorities){
                return this.getGeneralSettings.display_ticket_priorities.display_ticket_priorities
            }
        },
        totalFilters(){
            let date_check = this.temp_created_date.length ? this.temp_created_date.length - 1 : 0
            return date_check + this.ticket_number.length + this.assignedCustomer.length + this.behalf_selected.length + this.product.length + this.pending.length + this.entered_tag.length + this.templates.length + this.approvers.length;
        },

        getAllFiltersAPI(){
            return debounce(this.getAllFiltersAPIDebouncer, 250)
        },
        getAllAssignTo(){
            // this.assign_loading = true
            return debounce(this.getAllAssignToDebouncer, 250)
        }, 
        getAllTemplates(){
            this.template_options = []
            return debounce(this.getAllTemplatesDebouncer, 250)
        },
        getAllTagsAPI(){
            return debounce(this.getAllTagsAPIDebouncer, 250)
        },
        getAllApproversAPI(){
            return debounce(this.getAllApproversAPIDebouncer, 250)
        },
        getAllTicketAPI(){
            return debounce(this.getAllTicketAPIDebouncer, 250)
        }
    },
    async mounted(){
        this.templates = this.showfilterData.created_templates
        this.approvers = this.showfilterData.approvers
        this.created_date = this.showfilterData.created_date
        this.entered_tag = this.showfilterData.created_tags
        this.saveFilter = this.showfilterData.saveFilter
        if(this.created_date.length){
            this.temp_created_date = [];
            this.temp_created_date[0] = this.dateFormat(this.created_date[0],'yyyy-MM-dd')
            this.temp_created_date[1] = this.dateFormat(this.created_date[1],'yyyy-MM-dd')
        }
        this.last_modified_date = this.showfilterData.last_modified_date
        this.branch = this.showfilterData.branch
        this.ticket_number = this.showfilterData.ticket_number
        this.priority = this.showfilterData.priority
        this.company_name = this.showfilterData.company_name
        this.department = this.showfilterData.department
        this.pending = this.showfilterData.status
        this.product = this.showfilterData.product
        this.assignedCustomer = this.showfilterData.assigned_to
        this.template = this.showfilterData.template
        this.ticket_type = this.showfilterData.ticket_type
        this.assign_to_whom = this.showfilterData.assign_to_whom
        this.behalf_of_whom = this.showfilterData.behalf_of_whom
        this.behalf_selected= this.showfilterData.behalf_selected
        this.jobType = this.showfilterData.jobType
        // this.loadBranchs()
        // this.loadDept()
        // this.loadTemplates()
        // this.pending_options.forEach(el=> {
        //     if(el.ticket_status == 'Re-Open') {
        //         el.ticket_status = 'Re-Opened'
        //     }
        // })
        EventBus.$on('clear_selected_filter', () => {
            this.clearAllSelected()
        })
    },
    created() {

    }
}
</script>
<style scoped>
    .inputFilter {
        font-size: 14px;
        padding: 10px;
        display: block;
        height: 44px;
        width: 100%;
        border: none;
        color: #808495 !important;
        background-color: #ffffff;
        border-radius: 8px;
        font-weight: 500;
        margin-top: 10px;
        font-family: 'Poppins', sans-serif !important;
    }
    .inputFilter::placeholder{
        color: #808495;
        font-weight: normal !important;
    }
    .mx-datepicker.actiondate .mx-input {
        display: inline-block;
        width: 100%;
        height: 40px !important;
        padding: 6px 6px !important;
        font-size: 14px;
        line-height: 1.4;
        color: #ffffff;
        background-color: #4d8ddd !important;
        border: 1px solid #0475f3 !important;
        border-radius: 8px !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        text-align: left !important;
    }
    .saveAs{
        position: absolute;
        top: 35px;
        background-color: #ffffff;
        padding: 10px;
        border-radius: 5px;
        font-family: 'Poppins', sans-serif !important;
    }
    ._close{
        float: right;
    }
    .date-pop .mx-datepicker-popup{
        position: relative;
        top: 0px;
    }
    .scm-filters {
        position: fixed;
        top: 50px;
        left: 0;
        width: 100%;
        background: #e6ecff !important;
        height: 100%;
        border-radius: 0 !important;
        overflow: scroll !important;
        padding-bottom: 80px;
    }

    .clear-icon{
        position: absolute;
        top: 13px;
        left: 337px;
        background-color: #fff;
    }
    .filterSelectedName{
        max-width: 225px !important;
    }
</style>